var scope_0 = require('/builds/vugs1/products/internet-sanitizer/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/36962e8ed713705ce1234199589a17a3.js').default;
var scope_1 = require('/builds/vugs1/products/internet-sanitizer/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5bc193fefcc1fc3e0a80f444fa17c231.js').default;
var scope_2 = require('/builds/vugs1/products/internet-sanitizer/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/68600d25233a6f66b2addd130d76241a.js').default;
var scope_3 = require('/builds/vugs1/products/internet-sanitizer/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b8fd9b9f2bdc7ee8e4a7dc596d572ab9.js').default;
var scope_4 = require('/builds/vugs1/products/internet-sanitizer/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bd92343cf2c344b6adf7f4434667a326.js').default;
var scope_5 = require('/builds/vugs1/products/internet-sanitizer/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c7511e10b80e79ac7c17d57c0ffe21ce.js').default;
var scope_6 = require('/builds/vugs1/products/internet-sanitizer/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d92a4213749b0184ca1e9d975f1efb43.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6 )
    